import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EventsService } from '@app/services/events.service';
import { WebSocketService } from '@app/services/websocket.service';

@Component({
  selector: 'persistent-alerts',
  templateUrl: './persistent-alerts.component.html',
  styleUrls: ['./persistent-alerts.component.scss'],
})
export class PersistentAlertsComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  persistentAlertBell: Howl;
  closeCheckInterval: any;

  constructor(
    public dialogRef: MatDialogRef<PersistentAlertsComponent>,
    public socketService: WebSocketService,
    public alertService: EventsService
  ) {
    //make sure custid is present
    this.alertService.initializeService();

    //start howling...
    this.persistentAlertBell = new Howl({
      src: ['assets/sounds/alert_bell_1.mp3'],
      autoplay: true,
      loop: true,
      onstop: function () {
        //console.log('stopped howl');
      },
    });
  }

  ngOnInit(): void {
    //hacky but effective MKL
    this.closeCheckInterval = setInterval(() => {
      if (this.socketService.perAlerts.length == 0) {
        //console.log('close from interval');
        this.close();
      }
    }, 500);
  }

  ngOnDestroy(): void {
    clearInterval(this.closeCheckInterval);
  }

  ngAfterViewInit(): void {
    //console.log('persistent');
  }

  closedCard() {
    //console.log('closed a card');
    //console.log(this.socketService.perAlerts);
    if (this.socketService.perAlerts.length <= 0) {
      this.persistentAlertBell.stop();
      this.dialogRef.close();
    }
  }

  close() {
    this.persistentAlertBell.stop();
    this.dialogRef.close();
  }
}
